export const LOADING_BAR_PORTAL_ID = 'loading-bar';
export const OVERLAY_ID = 'overlay';

export default {
    LOADING_BAR_PORTAL_ID,
    OVERLAY_ID
};
